module.exports = {"10x20": __webpack_public_path__ + "images/satellite-debris-small-1-20x10.png"};